import { LeagueId, ApolloPhase, NbaLeagueId } from "@suns/api";
// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { ReportQueryParams } from "@suns/api/generated-client/apollo";
import dayjs from "dayjs";

export { labsList } from "./labs";
export { glossaryList, StatName } from "./glossary";

export const Suns = {
  id: 1610612756,
  abbr: "PHX",
  fullName: "Phoenix Suns",
  leagueId: NbaLeagueId.NBA,
};

export const Mercury = {
  id: 1611661317,
  abbr: "PHO",
  fullName: "Phoenix Mercury",
  leagueId: NbaLeagueId.WNBA,
};

export const ValleySuns = {
  id: 1612709934,
  abbr: "VAL",
  fullName: "ValleySuns",
  leagueId: NbaLeagueId.GLEAGUE,
};

export const defaultFilterValues = {
  level: undefined,
  teamIds: [],
  playerIds: [],
  agentIds: [],
  personnelIds: [],
  authorUsername: [],
  status: ReportQueryParams.status.PUBLISHED,
  page: 0,
};

export const DEFAULT_TEAM_ID = {
  [NbaLeagueId.GLEAGUE]: ValleySuns.id,
  [NbaLeagueId.NBA]: Suns.id,
  [NbaLeagueId.WNBA]: Mercury.id,
};

export const AvailableLeagues = [
  LeagueId.NBA,
  LeagueId.NCAA,
  LeagueId.GLEAGUE,
  LeagueId.SPAIN,
  LeagueId.ITALY,
  LeagueId.AUSTRALIA,
  LeagueId.FRANCE_PRO_A,
  LeagueId.FRANCE_PRO_B,
  LeagueId.GREECE,
  LeagueId.TURKEY,
  LeagueId.RUSSIA,
  LeagueId.EURO_LEAGUE,
  LeagueId.EURO_CUP,
  LeagueId.CHAMPIONS_LEAGUE,
];

export const CURRENT_PHASE = ApolloPhase.PHASE_24_25_5;

export const CURRENT_SEASON = 2024;
export const CURRENT_SEASON_LABEL = "2024-25";

export const CURRENT_DATE = dayjs();

export const LEAGUE_SEASONS: Partial<
  Record<NbaLeagueId, { year: number; label: string }>
> = {
  [NbaLeagueId.GLEAGUE]: {
    year: 2024,
    label: "2024-25",
  },
  [NbaLeagueId.NBA]: {
    year: 2024,
    label: "2024-25",
  },
  [NbaLeagueId.WNBA]: {
    year: 2025,
    label: "2025",
  },
};

export const LEAGUE_POSSESSION_BASELINE: Partial<Record<NbaLeagueId, number>> =
  {
    [NbaLeagueId.GLEAGUE]: 80,
    [NbaLeagueId.NBA]: 100,
    [NbaLeagueId.WNBA]: 80,
  };

export enum Timeframe {
  ONE_SEASON = "1 Season",
  TWO_SEASONS = "2 Seasons",
  FIVE_SEASONS = "5 Seasons",
  MAX = "Max",
}
